<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editStates(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="blue">mdi-state-machine</v-icon>
                </a>
              </template>
              <span>{{ $t("States") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <FlowModal :ref="modalKey" @on-item-saved="onItemSaved" />
    <StatesModal :ref="statesModalKey" @on-item-saved="onItemSaved" />
  </div>
</template>

<script>
import FlowService from "@/services/FlowService";
import FlowModal from "@/components/administration/flow/FlowModal.vue";
import StatesModal from "@/components/administration/flow/StatesModal.vue";
import Utils from "@/ecm/common/Utils";

export default {
  components: {
    FlowModal,
    StatesModal,
  },

  data() {
    return {
      title: this.$t("Flows"),
      grid: {
        key: "flowGrid",
        dataSource: FlowService.getGrid(),
        columns: [
          {
            field: "Name",
            caption: this.$t("Name"),
            type: "string",
          },
          {
            field: "ContentTypesNames",
            caption: this.$t("ContentTypes"),
            type: "string",
          },
          {
            field: "DefFieldTitle",
            caption: this.$t("Field"),
            type: "string",
          },
          {
            field: "ActiveNotif",
            caption: this.$t("Alerts"),
            type: "boolean",
          },
          {
            field: "NotifyByEmail",
            caption: this.$t("NotifyByEmail"),
            type: "boolean",
          },
        ],
      },
      modalKey: "modalFlow",
      statesModalKey: "statesModal",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    statesModalInstance() {
      return this.$refs[this.statesModalKey];
    },
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    editStates(dto) {
      this.statesModalInstance.edit(dto);
    },
    editItem(dto) {
      this.modalInstance.edit(dto);
    },
    deleteItem(dto) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          FlowService.delete(dto.Id).then((result) => {
            if (result) {
              this.gridInstance.refresh();
              Utils.toast.success(
                this.$t("Flow") + " " + this.$t("DeletedSuccessfully")
              );
            }
          });
        }
      });
    },
    add() {
      this.modalInstance.new();
    },
    onItemSaved() {
      this.gridInstance.refresh();
    },
  },
};
</script>